import { render, staticRenderFns } from "./variant3.vue?vue&type=template&id=67cf1b52&scoped=true"
import script from "./variant3.vue?vue&type=script&lang=js"
export * from "./variant3.vue?vue&type=script&lang=js"
import style0 from "./variant3.vue?vue&type=style&index=0&id=67cf1b52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cf1b52",
  null
  
)

export default component.exports